/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { SerdesUtils } from "@amzn/coral-typescript-types-pieces";
import { CoralModel, modelRegistrySingleton, } from "ihm-js-coral-client";
/**
 * This entity captures the logistics function provided by the service provider. Logistics service can be the
 * basic activity of shipping, sorting, custom filling, freight forwarding etc. augmented with add-ons such as
 * age verification, COD, signed delivery etc. A service definition would be captured using primitive attributes
 * like transit times, package type etc in Logistics Service Authority.
 * Here, we just need ServiceId as a reference to a service defined in LSA. The consumers of the entity need to
 * resolve the actual service definition by calling LSA if any attributes are required.
 *
 * Some of the examples of logistics services are UPS Next Day, UPS Next Day Air, Royal Mail Tracked 24.
 *
 * Refer Conceptual Data Model in LSA doc for complete service definition:
 * https:\/\/amazon.awsapps.com\/workdocs\/index.html#\/document\/844fd1f442b95672c72a1f2d938065b8ad3d939c10b7190d472eab7b943bae83
 **/
export class LogisticsServiceIdentifier extends CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the LogisticsServiceIdentifier#clone(obj: PlainObjectFrom<LogisticsServiceIdentifier>) method.
     */
    constructor(__serviceIdNamespace, __serviceIdValue) {
        super();
        this.serviceIdNamespace = __serviceIdNamespace;
        this.serviceIdValue = __serviceIdValue;
    }
    /**
     * Create a shallow clone of LogisticsServiceIdentifier from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */
    static clone(obj) {
        return new LogisticsServiceIdentifier(obj.serviceIdNamespace, obj.serviceIdValue);
    }
    static fromJson(data) {
        return new LogisticsServiceIdentifier(SerdesUtils.identityFunction(data.serviceIdNamespace), SerdesUtils.identityFunction(data.serviceIdValue));
    }
    static toJson(data) {
        return Object.assign({
            serviceIdNamespace: SerdesUtils.identityFunction(data.serviceIdNamespace),
            serviceIdValue: SerdesUtils.identityFunction(data.serviceIdValue),
        });
    }
}
LogisticsServiceIdentifier.fullyQualifiedTypeName = "com.amazon.shipping.logisticsservice#LogisticsServiceIdentifier";
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(LogisticsServiceIdentifier);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [LogisticsServiceIdentifier] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateLogisticsserviceidentifier(data) {
    // TODO: Actually implement this!
    return data;
}
